import React from "react";
import { Button } from "@/shared/components/ui/button";
import { enqueueSnackbar } from "notistack";
import { Callout } from "@/shared/components/ui/callout";

const FeedbackPage: React.FC = () => {
  return (
    <div className="w-full px-12 py-12">
      <header className="mb-12">
        <p className="mb-1 text-sm font-medium text-brand">Design System</p>
        <h1 className="mb-3 font-sans text-2xl font-bold tracking-tight">Feedback</h1>
        <p className="text-sm leading-relaxed text-secondary">
          Components for communicating status and notifications to users.
        </p>
      </header>

      <div className="space-y-16">
        {/* Callout */}
        <section id="callout" className="scroll-mt-8 space-y-4">
          <div className="mb-4 border-b border-primary pb-3">
            <h2 className="font-sans text-lg font-semibold">Callout</h2>
            <p className="mt-1 text-sm text-secondary">
              Contextual feedback messages for user actions and system status.
            </p>
          </div>
          <div className="space-y-3">
            <Callout variant="neutral" title="Neutral Callout">
              This is a neutral callout with a title.
            </Callout>
            <Callout variant="info" title="Info Callout">
              This is an informational callout with a title.
            </Callout>
            <Callout variant="warning" title="Warning Callout">
              This is a warning callout with a title.
            </Callout>
            <Callout variant="error" title="Error Callout">
              This is an error callout with a title.
            </Callout>
            <Callout variant="brand" title="Brand Callout">
              This is a brand callout with a title.
            </Callout>
            <Callout
              variant="neutral"
              title="With actions and dismiss"
              onDismiss={() => {}}
              actions={
                <Button variant="link" className="text-brand underline">
                  View changes
                </Button>
              }
            >
              Supports an action row and a dismiss affordance.
            </Callout>
          </div>
        </section>

        {/* Toast */}
        <section id="toast" className="scroll-mt-8 space-y-4">
          <div className="mb-4 border-b border-primary pb-3">
            <h2 className="font-sans text-lg font-semibold">Toast</h2>
            <p className="mt-1 text-sm text-secondary">
              Temporary notification messages using Notistack.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button
              variant="outline"
              onClick={() =>
                enqueueSnackbar("This is a default toast message", {
                  variant: "default",
                })
              }
            >
              Default Toast
            </Button>
            <Button
              variant="outline"
              onClick={() => enqueueSnackbar("Success!", { variant: "success" })}
            >
              Success Toast
            </Button>
            <Button
              variant="outline"
              onClick={() => enqueueSnackbar("Error! Something went wrong.", { variant: "error" })}
            >
              Error Toast
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                enqueueSnackbar("Warning! Please review your input.", { variant: "warning" })
              }
            >
              Warning Toast
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                enqueueSnackbar("Info: Here is some helpful information.", { variant: "info" })
              }
            >
              Info Toast
            </Button>
          </div>
          <p className="text-sm text-secondary">
            Click any button above to trigger a toast notification.
          </p>
        </section>
      </div>
    </div>
  );
};

export default FeedbackPage;
